<template>
  <div>
    <b-form-select
      value-field="id"
      text-field="name"
      @change="onSchemeSelect"
      v-model="schemeId"
      :options="schemes"
    ></b-form-select>

    <data-table
      v-if="schemeId != null"
      :items="items"
      v-on:updateData="getDebits"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button class="ml-2" @click="showModal()" variant="primary">
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-3">Debtor</div>
        <div class="col-md-2">Type</div>
        <div class="col-md-2">Amount</div>
        <div class="col-md-4">Note</div>
        <div class="col-md-1 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-3 my-auto">
          <p class="m-0" v-if="slotProps.item.debtor">
           <strong> {{ slotProps.item.debtor.name }} </strong><br>
              {{
              moment(new Date(slotProps.item.created_at)).format("DD MMM YY, HH:mm")
            }}
          </p>
        </div>

        <div class="col-md-2 my-auto">
         {{ slotProps.item.debit_type }}
        </div>

        <div class="col-md-2 my-auto">
          {{ slotProps.item.amount || currency }}
        </div>
        <div class="col-md-4 my-auto">
        {{ slotProps.item.note }}
        </div>

        <div class="col-md-1 my-auto text-left text-md-right pt-3 pt-md-0">
          <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Reverse"
            @click="reverseDebit(slotProps.item)"
            class="text-danger table-action-icon"
          >
            <i class="lni lni-cross-circle"></i>
          </span>
        </div>
      </template>
    </data-table>

    <b-modal v-model="createModal" title="Create Debit" :hide-footer="true">
      <form-group label="Amount" :required="true">
        <input type="number" class="form-control" v-model="newDebit.amount" />
      </form-group>

      <form-group label="Type" :required="true">
        <b-form-select
          v-model="newDebit.debit_type"
          :options="debitTypes"
        ></b-form-select>
      </form-group>

      <form-group label="Note" :required="true">
        <input class="form-control" v-model="newDebit.note" />
      </form-group>

      <button class="btn btn-success float-right" @click="createDebit()">Create</button>
    </b-modal>
  </div>
</template>

<script>
import contributionRepo from "@/api/repos/contributionRepo";
import schemeRepo from "@/api/repos/schemeRepo";
import dataTable from "@/components/common/DataTable";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    dataTable: dataTable,
    formGroup
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Newest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Newest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
      debitTypes: [],
      schemes: [{ id: null, name: "Please select a scheme" }],
      schemeId: null,
      createModal: false,
      newDebit: {},
    };
  },
  mounted() {
    this.getSchemes();
    this.getDebitTypes();
  },
  methods: {
    showModal() {
      this.createModal = true;
    },
    monthFormatter(value) {
      return this.months[value];
    },
    async getSchemes() {
      try {
        let { data } = await schemeRepo.schemes(
          1,
          10000,
          "name",
          "asc",
          "",
          null
        );
        data.schemes.data.forEach((x) => this.schemes.push(x));
      } catch (e) {
        console.log(e);
      }
    },
    async getDebitTypes() {
      try {
        let { data } = await contributionRepo.debitTypes();
        data.debit_types.forEach((x) => {
          this.debitTypes.push({
            text: x,
            value: x,
          });
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getDebits(e) {
      this.isLoad = true;
      try {
        let { data } = await contributionRepo.debits(
          this.schemeId,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.debits.data;
        this.totalRows = data.debits.total;
        this.page = data.debits.current_page;
        this.fromRow = data.debits.from;
        this.toRow = data.debits.to;
        this.lastPage = data.debits.last_page;

        
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    

    onSchemeSelect() {
      this.schemes = this.schemes.filter((x) => x.id != null);

      this.getDebits({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });
    },

    async createDebit(){
      if(this.newDebit.note == null || this.newDebit.amount == null || this.newDebit.debit_type == null){
        this.$bvToast.toast("Debit info missing", {
          title: "Failed",
          autoHideDelay: 3000,
          variant: "danger",
        });
      }

      try {
        await contributionRepo.debitCreate({
          ...this.newDebit,
          scheme_id:this.schemeId
        });

        this.createModal = false;
        this.getDebits({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });

        this.$bvToast.toast("Debit added", {
          title: "Added",
          autoHideDelay: 3000,
          variant: "success",
        });


      } catch (e) {
        console.log(e);
        this.$bvToast.toast("Debit adding failed", {
          title: "Failed",
          autoHideDelay: 3000,
          variant: "danger",
        });
      }
    },

    async reverseDebit(debit){
      this.$bvModal
        .msgBoxConfirm("Please confirm you want to reverse.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => {
          if(confirm){
            this.reverseConfirmed(debit);
          }
        })
        .catch((error) => console.log(error));
    },

    async reverseConfirmed(debit){
     try {
        await contributionRepo.reverseDebit(debit);
        this.getDebits({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 10,
        search: "",
      });

        this.$bvToast.toast("Debit Removed", {
          title: "Reversed",
          autoHideDelay: 3000,
          variant: "success",
        });


      } catch (e) {
        console.log(e);
        this.$bvToast.toast("Debit reverse failed", {
          title: "Failed",
          autoHideDelay: 3000,
          variant: "danger",
        });
      }
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
